import api from './api';
import { ApiResponse, unwrapApiResponse } from '@/utils/api-response.util';

export interface SetWebhookPayload {
  url: string;
}

export interface WebhookStatus {
  url: string;
  has_custom_certificate: boolean;
  pending_update_count: number;
  last_error_date?: number;
  last_error_message?: string;
  max_connections: number;
  allowed_updates?: string[];
  ip_address?: string;
}

export interface TelegramBotInfo {
  type: string;
  username: string;
  tokenConfigured: boolean;
  webhookInfo: WebhookStatus | null;
}

export interface GetBotsResponse {
  bots: TelegramBotInfo[];
}

export interface WebhookDiagnoseResponse {
  botUsername: string;
  tokenConfigured: boolean;
  webhookInfo: WebhookStatus | null;
  env: {
    NODE_ENV: string;
    hasToken: boolean;
    hasUsername: boolean;
  };
}

export const getBotsInfo = async (): Promise<TelegramBotInfo[]> => {
  const response = await api.get<ApiResponse<GetBotsResponse>>('/admin/telegram/bots');
  const data = unwrapApiResponse<GetBotsResponse>(response);
  return data?.bots || [];
};

export const setExpertWebhook = async (payload: SetWebhookPayload): Promise<void> => {
  await api.post<ApiResponse<void>>('/admin/telegram/webhook/expert', payload);
};

export const getExpertWebhookStatus = async (): Promise<WebhookDiagnoseResponse> => {
  const response = await api.get<ApiResponse<WebhookDiagnoseResponse>>('/admin/telegram/webhook/expert/status');
  return unwrapApiResponse<WebhookDiagnoseResponse>(response);
};
